<div class="header-row">
  <div class="heading-box">
    <div class="back">
      <a
        href=""
        (click)="goBack()"
        style="display: inline-flex; align-items: center"
      >
        <mat-icon
          style="font-size: 16px; display: inline-flex; align-items: center"
          >arrow_back</mat-icon
        >
        <span>Back</span></a
      >
    </div>
    <div class="heading">Mapping Result</div>
    <div class="divider">|</div>
    <div class="status-title">Extraction Status</div>
    <div class="status" [ngClass]="getStatusClass(extractionStatus)">
      {{ getExtractionStatusLabel(extractionStatus) }}
    </div>
  </div>
</div>
<div
  class="col-8 d-flex mt-2 _navigation"
  style="margin: 0 0 10px 10px; padding: 0 0 5px 5px"
>
  <motif-breadcrumb [maxItems]="5" truncateAt="mid">
    <motif-breadcrumb-item
      *ngFor="let nav of navigationList; let last = last"
      [breadcrumbValue]="nav.value"
      [expanded]="false"
      [ngClass]="last ? 'lastNav' : 'activeNav'"
      (breadcrumbClick)="onBreadcrumbClick(nav)"
      style="cursor: pointer"
      [motif-tooltip]="nav.value"
      placement="top"
    ></motif-breadcrumb-item>
  </motif-breadcrumb>
</div>
<div
  class="data-box p-8"
  style="background-color: #ffffff; border-radius: 10px"
>
  <div class="data-grid-box">
    <div class="title-box">
      <div class="title">
        Extracted Results
      </div>
      <div class="button-box" style="gap: 12px">
        <mat-slide-toggle
          [disabled]="dataSource.data.length === 0"
          class="small-toggle"
          (change)="onToggleEditMode($event)"
          [checked]="isEditMode"
          >Edit Results</mat-slide-toggle
        >
        <ng-container *ngIf="isEditMode">
          <button
            motifButton
            color="primary"
            size="small"
            [loading]="false"
            variant="null"
            (click)="bulkUpdateTable(); resetEditedFields();"
          >
            Save
          </button>
          <button
            class="secondary-btn"
            motifButton
            color="secondary"
            size="small"
            [loading]="false"
            variant="null"
            (click)="this.isEditMode = false; resetEditedFields();"
          >
            Cancel
          </button>
        </ng-container>
      </div>
    </div>
    <div
      class="custom-tabs-and-generate"
      style="
        display: flex;
        align-items: flex-start;
        margin-bottom: 10px;
        gap: 24px;
        width: 100%;
      "
    >
      <div
        style="flex: 1 1 auto; display: flex; gap: 8px; align-items: flex-start"
      >
        <span>
          <div class="custom-tab-filter">
            <div
              *ngFor="let tab of motifTabOptions"
              (click)="onTabClick(tab)"
              [ngClass]="{
                'custom-tab-active':
                  motifTabSelected.length === 1 && motifTabSelected[0] === tab,
                'custom-tab': true
              }"
            >
              <span
                style="
                  margin-left: 24px;
                  margin-right: 24px;
                  display: block;
                  width: 100%;
                  text-align: center;
                  font-size: 15px;
                  font-weight: 500;
                  user-select: none;
                "
              >
                {{ tab }}
              </span>
            </div>
          </div>
          <div
            style="
              display: flex;
              align-items: center;
             
              gap: 16px;
              width: 100%;
              margin-top: 8px;
            "
          >
            <motif-form-field
              style="
                width: 220px;
                min-width: 220px;
                margin-left: 0px;
                position: relative;
                display: inline-block;
                border-radius: 6px;
                border: 1px solid #7660ff;
              "
            >
              <label motifLabel>Search Data Element Name</label>
              <input
                motifInput
                type="text"
                [(ngModel)]="searchText"
                (ngModelChange)="onSearchTextChange()"
                style="padding-right: 40px; background-color: #ecedff"
              />
              <span
                style="
                  position: absolute;
                  right: 8px;
                  top: 60%;
                  transform: translateY(-50%);
                  cursor: pointer;
                  color: #757575;
                "
              >
                <mat-icon
                  *ngIf="searchText"
                  (click)="searchText = ''; onSearchTextChange()"
                  >close</mat-icon
                >
              </span>
            </motif-form-field>
            <div style="display:flex; align-items:center; gap:8px; margin-left:8px;">
              <button mat-icon-button aria-label="Filter validation" (click)="openValidationPopupAt($event)" style="width:36px; height:36px; background: transparent; border: none;" >
                <mat-icon [motif-tooltip]="'Validation Filter'" placement="top">filter_list</mat-icon>
              </button>
              <div *ngIf="showValidationFilterPopup" class="validation-filter-popup" [ngStyle]="{ position: 'fixed', top: validationPopupTop + 'px', left: validationPopupLeft + 'px', background: '#fff', border: '1px solid #ddd', boxShadow: '0 6px 20px rgba(0,0,0,0.18)', borderRadius: '6px', padding: '8px', zIndex: 30000, minWidth: '160px' }">
                <div style="display:flex; flex-direction:column; gap:6px; align-items: flex-start;">
                  <label style="font-size:13px; color:#333; display: flex; align-items: center; gap: 8px;">
                    <input type="checkbox" name="validationIconsOnly" [(ngModel)]="validationIconsOnly" (change)="filterDataSourceMotif()" /> Validated
                  </label>
                  <label style="font-size:13px; color:#333; display: flex; align-items: center; gap: 8px;">
                    <input type="checkbox" name="noValidationIconsOnly" [(ngModel)]="noValidationIconsOnly" (change)="filterDataSourceMotif()" /> Not Validated
                  </label>
                </div>
              </div>
            </div>
          </div>
        </span>
      </div>
      <div
        style="
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          justify-content: flex-end;
          min-width: 180px;
          gap: 8px;
        "
      >
        <button
          type="button"
          class="generateBtn"
          motifButton
          color="secondary"
          size="small"
          [loading]="false"
          variant="null"
          (click)="generateResult(); isModalOpen = true"
          style="margin-right: 0"
        >
          <img src="/generate-report.png" alt="Generate result" />
          <span>Generate Report</span>
        </button>
       <div style="display: flex; flex-direction: row; align-items: center; gap: 16px; margin-top: 8px; width: 100%; justify-content: flex-end;">
          <!-- update button is no longer needed
              <button
              type="button"
              matButton
              class="update-results-tooltip"
              [ngClass]="isUpdateResultsEnabled && !isUpdatingResults ? 'update-results-primary' : 'update-results-secondary'"
              size="small"
              style="margin-right: 0; height: 44px; display: flex; align-items: center;"
              [disabled]="!isUpdateResultsEnabled || isUpdatingResults"
              (click)="onUpdateResults()"
              [motif-tooltip]="''"
              [customTemplate]="!isUpdateResultsEnabled ? updateResultsTooltipDisabled : updateResultsTooltipEnabled"
              placement="top"
            >
          <span *ngIf="!isUpdatingResults">Update Results</span>
              <span *ngIf="isUpdatingResults">Updating...</span>
            </button>
          <ng-template #updateResultsTooltipDisabled>
            <div class="update-results-tooltip-content">Re-run extraction based on updates to Borrower Name, Guarantor/Sponsor Name, and Statement Dates</div>
          </ng-template> 
          <ng-template #updateResultsTooltipEnabled>
            <div class="update-results-tooltip-content">Update Results Enabled</div>
          </ng-template> -->
          <span
            class="responsive-summary-label"
            style="white-space: nowrap; font-size: 15px; align-self: center; height: 44px; display: flex; align-items: center;"
          >
            Reviewed Attributes: {{ feedbackSummary.reviewed }}/{{
              feedbackSummary.total
            }}
          </span>
        </div>
      </div>
    </div>
    <!-- Sectioned Table Rendering -->
    <div
      class="doc-box-content"
      style="max-height: 400px; overflow: auto; z-index: 99"
    >
      <ng-container *ngFor="let section of sectionOrder; let i = index">
        <div
          class="section-header"
          style="
            display: flex;
            align-items: center;
            justify-content: center;
            background: linear-gradient(90deg,#ecedff  0%, #bfc1f5 50%, #1976d2 100%);
            color: #000;
            border-top: 1px solid black;
            border-radius: 5px;
            padding: 6px 12px;
            cursor: pointer;
            text-align: center;
            position: sticky;
            top: 0;
            z-index: 10;
          "
          (click)="onSectionHeaderClick(i)"
        >
          <mat-icon style="margin-right: 8px; color: #000;">{{
            expandedSectionIndex === i ? "expand_less" : "expand_more"
          }}</mat-icon>
          <span
            style="
              font-weight: normal;
              font-size: 16px;
              flex: 1;
              text-align: left;
              font-family: EYInterstate !important;
            "
          >
            <span style="display:inline-flex; align-items:center; gap:8px;">
              <span>{{ section }}</span>
              <mat-icon
                *ngIf="shouldShowSectionIcon(section)"
                style="cursor: pointer; color: #000; font-size: 22px;margin-top: 4px;"
                [matTooltip]="'View in Read-Only Mode'"
                matTooltipPosition="above"
                (click)="$event.stopPropagation(); openSectionModal(section)"
              >
                visibility
              </mat-icon>
            </span>
          </span>
        </div>
        <div *ngIf="expandedSectionIndex === i">
          <table
            mat-table
            [dataSource]="sectionDataSources[section]"
            class="mat-elevation-z8"
            style="margin-bottom: 24px; overflow: hidden"
          >
            <ng-container matColumnDef="attribute_name">
              <th
                mat-header-cell
                *matHeaderCellDef
                style="text-wrap: nowrap"
              >
                Attribute Name
              </th>
              <td mat-cell *matCellDef="let row">
                <ng-container *ngIf="!row.isDependent; else dependentName">
                  <div class="attr-cell" style="display: flex; flex-direction: column; align-items: flex-start;">
                    <span class="attr-name" [motif-tooltip]="row.data_element_name" placement="top">{{ row.data_element_name }}</span>
                    <div style="display: flex; flex-direction: row; align-items: center; margin-top: 4px; margin-bottom: 8px; height: 12px; margin-left: 20px;">
                      <button
                        *ngIf="hasDependents(row)"
                        type="button"
                        class="dep-toggle-btn"
                        (click)="toggleDependents(row, section); $event.stopPropagation()"
                        [motif-tooltip]="row.dependentExpanded ? 'Collapse dependents' : 'Expand dependents'"
                        placement="top"
                        style="background-color: #7660ff; color: white; border-radius: 50%; width: 14px; height: 14px; min-width: 14px; min-height: 14px; display: flex; align-items: center; justify-content: center; border: none; padding: 0; line-height: 0;"
                      >
                      <mat-icon class="dep-toggle-icon" fontSet="material-icons" style="color: white; font-size: 12px; display: flex; align-items: center; justify-content: center; width: 100%; height: 100%; line-height: 1; margin-bottom: 4px;">{{ row.dependentExpanded ? 'remove' : 'add' }}</mat-icon>
                      </button>
                      <button class="history-button cra-button button-light" mat-icon-button (click)="openHistoryModal(row)" [motif-tooltip]="'Show history'" placement="top" style="border-radius: 6px; border: 2px solid #7660ff; color: #7660ff; background: transparent; width: 24px; height: 24px; min-width: 24px; min-height: 24px; display: flex; align-items: center; justify-content: center; padding: 0;margin-top: 8px;">
                        <mat-icon style="color: #7660ff; font-size: 16px;">menu_book</mat-icon>
                      </button>
                      <button *ngIf="row.ai_answer_list && row.ai_answer_list.length > 0" mat-icon-button (click)="openDependentValueModal(row); $event.stopPropagation()" [motif-tooltip]="'Tape Source Comparison'" placement="top" style="border-radius: 6px; border: none; color: #1976d2; background: transparent; width: 24px; height: 24px; min-width: 24px; min-height: 24px; display: flex; align-items: center; justify-content: center; padding: 0;margin-top: 8px;">
                        <mat-icon style="color: #1976d2; font-size: 16px;">post_add</mat-icon>
                      </button>
                    </div>
                  </div>
                </ng-container>
                <ng-template #dependentName>
                  <div class="dependent-left-margin" style="display: flex; flex-direction: column; align-items: stretch;">
                    <div style="display: flex; align-items: center; gap: 8px; justify-content: flex-start;">
                      <mat-icon class="leaf-icon" fontSet="material-icons" style="margin-left: 0;margin-top: 8px;">subdirectory_arrow_right</mat-icon>
                      <span class="leaf-text" [motif-tooltip]="row.data_element_name" placement="top">{{ row.data_element_name }}</span>
                    </div>
                      <div style="display: flex; flex-direction: row; align-items: center; justify-content: center; margin-top: 4px; height: 12px; width: 100%;">
                      <button
                        *ngIf="hasDependents(row)"
                        type="button"
                        class="dep-toggle-btn"
                        (click)="toggleDependents(row, section); $event.stopPropagation()"
                        [motif-tooltip]="row.dependentExpanded ? 'Collapse dependents' : 'Expand dependents'"
                        placement="top"
                        style="background-color: #7660ff; color: white; border-radius: 50%; width: 14px; height: 14px; min-width: 14px; min-height: 14px; display: flex; align-items: center; justify-content: center; border: none; padding: 0; margin-bottom: 4px;"
                      >
                        <mat-icon class="dep-toggle-icon" fontSet="material-icons" style="color: white; font-size: 14px;">{{ row.dependentExpanded ? 'remove' : 'add' }}</mat-icon>
                      </button>
                      <button class="history-button cra-button button-light" mat-icon-button (click)="openHistoryModal(row)" [motif-tooltip]="'Show history'" placement="top" style="border-radius: 6px; margin-bottom: 10px; border: 2px solid #7660ff; color: #7660ff; background: transparent; width: 24px; height: 24px; min-width: 24px; min-height: 24px; display: flex; align-items: center; justify-content: center; padding: 0;margin-top: 8px;">
                        <mat-icon style="color: #7660ff; font-size: 16px;">menu_book</mat-icon>
                      </button>
                      <button *ngIf="row.ai_answer_list && row.ai_answer_list.length > 0" mat-icon-button (click)="openDependentValueModal(row); $event.stopPropagation()" [motif-tooltip]="'Tape Source Comparison'" placement="top" style="border-radius: 6px; border: none; color: #1976d2; background: transparent; width: 24px; height: 24px; min-width: 24px; min-height: 24px; display: flex; align-items: center; justify-content: center; padding: 0;margin-top: 8px;">
                        <mat-icon style="color: #1976d2; font-size: 16px;">post_add</mat-icon>
                      </button>
                    </div>
                  </div>
                </ng-template>
              </td>
            </ng-container>
            <ng-container matColumnDef="value">
              <th mat-header-cell *matHeaderCellDef style="color: #111;">{{ (isRegulatory(section) || isRegulatoryActive()) ? 'Condensed Summary' : 'Results' }}</th>
              <td mat-cell *matCellDef="let row" style="color: #111;">
                <ng-container *ngIf="!row.isDependent; else depValue">
                  <ng-container *ngIf="!isEditMode">
                    <div *ngIf="getDisplaySourceLabel(row)" style="font-size:12px;color:#888;margin-bottom:4px">({{ getDisplaySourceLabel(row) }})</div>
                    <ng-container *ngIf="getDisplayValue(row) !== null && (getDisplayValue(row) + '').length > 100">
                      <span style="color: #111;">
                        <markdown [data]="toMarkdownString(getTruncated(getDisplayValue(row), 100) + '...')" class="ai-answer-markdown truncated"></markdown>
                        <a href="#" (click)="$event.preventDefault(); openAnswerModal(getDisplayValue(row))" class="md-toggle-link" style="color: #1976d2;">Show more</a>
                      </span>
                    </ng-container>
                    <ng-container *ngIf="getDisplayValue(row) !== null && (getDisplayValue(row) + '').length <= 100">
                      <span style="color: #111;">
                        <markdown [data]="toMarkdownString(getDisplayValue(row))" class="ai-answer-markdown full"></markdown>
                      </span>
                    </ng-container>
                    <div *ngIf="getDisplayValue(row) && (expandedRows[row.data_element_name] === true)" style="margin-top:8px; padding:8px; border-left: 3px solid #e0e0e0; background: #fafafa; border-radius:4px;">
                      <ng-container *ngIf="getDisplayValue(row) !== null && (getDisplayValue(row) + '').length > 100">
                        <markdown [data]="toMarkdownString(getTruncated(getDisplayValue(row), 100) + '...')" class="ai-answer-markdown truncated"></markdown>
                        <a href="#" (click)="$event.preventDefault(); openAnswerModal(getDisplayValue(row))" class="md-toggle-link" style="color: #1976d2;">Show more</a>
                      </ng-container>
                      <ng-container *ngIf="getDisplayValue(row) !== null && (getDisplayValue(row) + '').length <= 100">
                        <markdown [data]="toMarkdownString(getDisplayValue(row))" class="ai-answer-markdown full"></markdown>
                      </ng-container>
                      <ng-container *ngIf="!getDisplayValue(row)">
                        <div style="color:#888">No additional result available</div>
                      </ng-container>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="isEditMode">
                    <textarea matInput class="grid-input"
                      [value]="row.ai_answer"
                      (change)="onFieldEdit(row)"
                      [(ngModel)]="row.ai_answer"
                      [disabled]="isFieldDisabled(row)"
                      [ngStyle]="isFieldDisabled(row) ? {'background-color': '#f0f0f0', 'color': '#888'} : {'color': '#111'}"
                      style="white-space: pre-wrap;" rows="4"></textarea>
                  </ng-container>
                </ng-container>
                <ng-template #depValue>
                  <div class="dependent-left-margin">
                    <ng-container *ngIf="!isEditMode">
                      <div *ngIf="getDisplaySourceLabel(row)" style="font-size:12px;color:#888;margin-bottom:4px">({{ getDisplaySourceLabel(row) }})</div>
                      <ng-container *ngIf="getDisplayValue(row) !== null && (getDisplayValue(row) + '').length > 100">
                        <span style="color: #111;">
                          <markdown [data]="toMarkdownString(getTruncated(getDisplayValue(row), 100) + '...')" class="ai-answer-markdown truncated"></markdown>
                          <a href="#" (click)="$event.preventDefault(); openAnswerModal(getDisplayValue(row))" class="md-toggle-link" style="color: #1976d2;">Show more</a>
                        </span>
                      </ng-container>
                      <ng-container *ngIf="getDisplayValue(row) !== null && (getDisplayValue(row) + '').length <= 100">
                        <span style="color: #111;">
                          <markdown [data]="toMarkdownString(getDisplayValue(row))" class="ai-answer-markdown full"></markdown>
                        </span>
                      </ng-container>
                      <div *ngIf="getDisplayValue(row) && (expandedRows[row.data_element_name] === true)" style="margin-top:8px; padding:8px; border-left: 3px solid #e0e0e0; background: #fafafa; border-radius:4px;">
                        <ng-container *ngIf="getDisplayValue(row) !== null && (getDisplayValue(row) + '').length > 100">
                          <markdown [data]="toMarkdownString(getTruncated(getDisplayValue(row), 100) + '...')" class="ai-answer-markdown truncated"></markdown>
                          <a href="#" (click)="$event.preventDefault(); openAnswerModal(getDisplayValue(row))" class="md-toggle-link" style="color: #1976d2;">Show more</a>
                        </ng-container>
                        <ng-container *ngIf="getDisplayValue(row) !== null && (getDisplayValue(row) + '').length <= 100">
                          <markdown [data]="toMarkdownString(getDisplayValue(row))" class="ai-answer-markdown full"></markdown>
                        </ng-container>
                        <ng-container *ngIf="!getDisplayValue(row)">
                          <div style="color:#888">No additional result available</div>
                        </ng-container>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="isEditMode">
                      <textarea matInput class="grid-input"
                        [value]="row.ai_answer"
                        (change)="onFieldEdit(row)"
                        [(ngModel)]="row.ai_answer"
                        [disabled]="isFieldDisabled(row)"
                        [ngStyle]="isFieldDisabled(row) ? {'background-color': '#f0f0f0', 'color': '#888'} : {'color': '#111'}"
                        style="white-space: pre-wrap;" rows="4"></textarea>
                    </ng-container>
                  </div>
                </ng-template>
              </td>
            </ng-container>
            <ng-container matColumnDef="validation">
              <th mat-header-cell *matHeaderCellDef style="text-align: center;">
                Validation
              </th>
              <td mat-cell *matCellDef="let row" style="text-align: center;">
                <ng-container *ngIf="row.ai_answer_list && row.ai_answer_list.length > 0">
                  <ng-container *ngIf="computeValidationState(row) as vstate">
                    <button mat-icon-button disableRipple (click)="openValidationSourceModal(row)" [motif-tooltip]="'Validation Status'" placement="top" style="margin-left:8px; background: transparent !important; border: none !important; box-shadow: none !important; outline: none !important; padding-top:10px">
                      <mat-icon [style.color]="vstate.color" style="font-size:16px">{{ vstate.icon }}</mat-icon>
                    </button>
                  </ng-container>
                </ng-container>
              </td>
            </ng-container>
            <ng-container matColumnDef="rationale">
              <th mat-header-cell *matHeaderCellDef class="grid-body-bold">
                {{ (isRegulatory(section) || isRegulatoryActive()) ? 'Summary Conclusion' : 'AI Rationale' }}
              </th>
              <td mat-cell *matCellDef="let row">
                <app-custom-tooltip class="doc-icon-wrapper" [content]="toMarkdownString(row.ai_rationale === 'Information not found in the documents.' ? '--' : (row.ai_rationale || '--'))" [useMarkdown]="true" [width]="'360px'">
                  <img src="/images/rationale.png" alt="Rationale" class="rationale-icon" (click)="openAiInsightDialog(row, section)" />
                </app-custom-tooltip>
              </td>
            </ng-container>
            <ng-container matColumnDef="source_documents">
              <th mat-header-cell *matHeaderCellDef style="text-align: center;text-wrap: nowrap;">
                Source Documents
                <div
                  style="
                    font-size: 11px;
                    color: #888;
                    font-weight: normal;
                    text-align: center;
                  "
                >
                  (Click to view document)
                </div>
              </th>
              <td mat-cell *matCellDef="let row" style="text-align: center">
                <ng-container *ngFor="let item of row.traces">
                  <ng-container *ngIf="!isLevel2(row)">
                    <app-custom-tooltip class="doc-icon-wrapper" [content]="getChunkTooltipMarkdown(item)" [useMarkdown]="true" [width]="'320px'">
                      <mat-icon
                        class="chunk-icon"
                        (click)="showSourceDoc(item)"
                        [ngStyle]="{ color: isPdfItem(item) ? '#D32F2F' : '#388E3C' }"
                      >
                        {{ isPdfItem(item) ? 'picture_as_pdf' : 'description' }}
                      </mat-icon>
                    </app-custom-tooltip>
                  </ng-container>
                </ng-container>
              </td>
            </ng-container>
            <ng-container matColumnDef="confidence_level_percentage">
              <th mat-header-cell *matHeaderCellDef style="text-align: center;">
                AI Confidence (%)
              </th>
              <td mat-cell *matCellDef="let row" style="text-align: center">
                <span [ngClass]="row.isDependent ? 'dependent-left-margin' : ''">{{ row.confidence_level_percentage * 100 | number : '1.0-2' }}%</span>
              </td>
            </ng-container>
            <ng-container matColumnDef="feedback">
              <th mat-header-cell *matHeaderCellDef>Feedback</th>
              <td mat-cell *matCellDef="let row">
                <div class="reaction-buttons" [ngClass]="row.isDependent ? '10px' : ''">
                  <button mat-icon-button (click)="onThumbsUp(row)" [disabled]="row.confidence_level_validation === true" style="background-color: transparent; border: none" [motif-tooltip]="'Mark as correct'" placement="top">
                    <mat-icon [style.color]="row.confidence_level_validation === true ? '#1976d2' : row.confidence_level_validation === null ? '#bdbdbd' : '#bdbdbd'" style="font-size: 14px">thumb_up</mat-icon>
                  </button>
                  <button mat-icon-button (click)="openFeedbackCategoryModal(row, true)" [disabled]="row.confidence_level_validation === false" style="background-color: transparent; border: none" [motif-tooltip]="'Mark as incorrect'" placement="top">
                    <mat-icon [style.color]="row.confidence_level_validation === false ? ((row.category_name || '').toLowerCase().includes('partially correct') ? '#fbc02d' : '#d32f2f') : row.confidence_level_validation === null ? '#bdbdbd' : '#bdbdbd'" style="font-size: 14px">thumb_down</mat-icon>
                  </button>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="comments">
              <th mat-header-cell *matHeaderCellDef>Comments</th>
              <td mat-cell *matCellDef="let row" style="text-align: center;">
                <span [ngClass]="row.isDependent ? 'dependent-left-margin' : ''">
                  <mat-icon
                    class="feedback-icon cra-button button-light"
                    (click)="openCommentModal(row)"
                    [matBadge]="commentCounts[row.data_element_name] || 0"
                    [matBadgeHidden]="!commentCounts[row.data_element_name]"
                    matBadgePosition="below after"
                    matBadgeColor="warn"
                    [svgIcon]="'feedback'"
                    aria-hidden="false"
                  ></mat-icon>
                </span>
              </td>
            </ng-container>
            <tr
              mat-header-row
              *matHeaderRowDef="[
                'attribute_name',
                'value',
                'validation',
                'rationale',
                'source_documents',
                'confidence_level_percentage',
                'feedback',
                'comments'
              ]"
              sticky
            ></tr>
            <tr mat-row *matRowDef="let row; columns: ['attribute_name','value','validation','rationale','source_documents','confidence_level_percentage','feedback','comments']" [class.dependent-row]="row.isDependent"></tr>
          </table>
           </div>
            </ng-container>
</div>
</div>
</div>
          <!-- <div class="motif-row mx-4 mb-4 mt-1">
  <div class="motif-col-lg-6 motif-col-md-8 motif-col-sm-4">
    <div class="title">Result</div>
  </div>
  <div class="motif-col-lg-6 motif-col-md-8 motif-col-sm-4">
    <div style="display: flex; justify-content: flex-end">
      <button
        type="button"
        class="generateBtn"
        (click)="generateResult(); isModalOpen = true"
      >
        <img src="/generate-report.png" alt="Generate result" />
        <span>Generate Report</span>
      </button>
    </div>
  </div>
</div> -->

          <!-- <div class="result-box">
  <div class="title-box">
    <div class="button-box"></div>
  </div>
  <div class="result-box-content">
    <div class="result-box-no-data">
      <div class="img-box">
        <img src="images/no-file.png" alt="" />
      </div>
      <div class="no-data-text">No result available.</div>
      <div class="no-data-sub-text">
        User can only generate results after confirming the validation.
      </div>
    </div>
  </div>
</div> -->

          <!-- The Modal -->
          <div
            id="myModal"
            class="modal"
            [ngStyle]="{ display: isModalOpen ? 'block' : 'none' }"
          >
            <div class="modal-content  generate-report-modal" style="position: relative">
              <span
                class="close"
                (click)="isModalOpen = false"
                style="
                  position: absolute;
                  top: 10px;
                  right: 16px;
                  font-size: 28px;
                  cursor: pointer;
                "
                >&times;</span
              >
              <div class="text-center">
                Please select the option to generate the result.
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    margin: 12px 0;
                    gap: 8px;
                  "
                >
                  <div
                    style="
                      font-weight: 500;
                      font-size: 15px;
                      color: #2e2e38;
                      margin-bottom: 8px;
                    "
                  >
                    Subproduct: {{ sub_product || "N/A" }}
                  </div>
                  <div
                    style="width: 100%; display: flex; justify-content: center"
                  >
                    <motif-form-field style="min-width: 220px">
                      <label motifLabel>Select Tab</label>
                      <motif-select
                        [(ngModel)]="selectedTabName"
                        (ngModelChange)="onGenerateTabChange($event)"
                        [multiple]="false"
                        placeholder="Select tab"
                        labelPosition="inside"
                        style="width: 100%"
                      >
                        <motif-option
                          *ngFor="let tab of tabNames"
                          [value]="tab"
                          >{{ tab }}</motif-option
                        >
                      </motif-select>
                    </motif-form-field>
                  </div>
                   <!-- Read-only attributes accordion (shows for certain tabs) -->
                    <div *ngIf="selectedTabName === 'All' && hasAnyReadonlyAttributes()" style="width:100%; display:flex; justify-content:center; margin-top:8px;">
                      <div class="readonly-attributes-multi" role="group" aria-label="View attributes for all tabs">
                        <ng-container *ngFor="let tab of tabNames">
                          <ng-container *ngIf="tab !== 'All' && readonlyAttributesMap && readonlyAttributesMap[tab] && readonlyAttributesMap[tab].length > 0">
                            <details class="readonly-attributes-multi-item">
                              <summary class="readonly-attributes-summary">{{ tab }} ({{ readonlyAttributesMap[tab].length }})</summary>
                              <ul class="readonly-attributes-list">
                                <li *ngFor="let attr of readonlyAttributesMap[tab]" class="readonly-attributes-item">{{ attr }}</li>
                              </ul>
                            </details>
                          </ng-container>
                        </ng-container>
                      </div>
                    </div>

                    <div *ngIf="selectedTabName !== 'All' && readonlyAttributesMap && readonlyAttributesMap[selectedTabName] && readonlyAttributesMap[selectedTabName].length > 0" style="width:100%; display:flex; justify-content:center; margin-top:8px;">
                      <details class="readonly-attributes" role="group" aria-label="View attributes">
                        <summary class="readonly-attributes-summary">View attributes ({{ readonlyAttributesMap && readonlyAttributesMap[selectedTabName] ? readonlyAttributesMap[selectedTabName].length : 0 }})</summary>
                        <ul class="readonly-attributes-list">
                          <li *ngFor="let attr of (readonlyAttributesMap && readonlyAttributesMap[selectedTabName] ? readonlyAttributesMap[selectedTabName] : [])" class="readonly-attributes-item">{{ attr }}</li>
                        </ul>
                      </details>
                    </div>
                  <div
                    style="margin-top: 8px; font-size: 10px; font-weight: bold; font-family: EYInterstate; display:flex; align-items:center; gap:8px;">
                    <span> <span aria-hidden="true"
                        style="color:#d32f2f; font-size:12px;margin-right:4px; font-weight:700; line-height:1;">!</span>Not all
                      tape-to-source comparison attributes have been validated. You may proceed, but the generated line sheet could be
                      incomplete.</span>
                  </div>
                </div>
                <div
                  style="
                    display: flex;
                    gap: 12px;
                    justify-content: center;
                    margin-top: 8px;
                  "
                >
                  <!-- <button
          type="button"
          class="secondary-btn"
          (click)="isModalOpen = false"
          [disabled]="true"
          style="cursor: not-allowed; background-color: #e0e0e0; color: #9e9e9e; z-index: 9999;"
        >
          Default
        </button>
        <button
          type="button"
          class="secondary-btn"
          (click)="isModalOpen = false; isUploadModalOpen = true"
        >
          Upload Document
        </button> -->
                  <button
                    type="button"
                    class="secondary-btn"
                    style="background-color: #7660ff; color: #fff; border: none"
                    (click)="onGenerateTabReport()"
                  >
                    Generate
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Upload Document Modal -->
          <div
            id="uploadModal"
            class="modal"
            [ngStyle]="{ display: isUploadModalOpen ? 'block' : 'none' }"
          >
            <div class="modal-content" style="position: relative">
              <span
                class="close"
                (click)="isUploadModalOpen = false"
                style="
                  position: absolute;
                  top: 10px;
                  right: 16px;
                  font-size: 28px;
                  cursor: pointer;
                "
                >&times;</span
              >
              <div style="padding-top: 40px" class="text-center">
                <input
                  type="file"
                  class="secondary-btn"
                  (change)="onFileSelected($event)"
                />
                <div style="position: relative; min-height: 60px">
                  <button
                    class="uploadBtn"
                    (click)="onUpload()"
                    [disabled]="IsLoader"
                  >
                    Upload Document
                  </button>
                  <motif-progress-loader
                    [show]="IsLoader"
                    [fullScreen]="true"
                  ></motif-progress-loader>
                </div>
              </div>
            </div>
          </div>
          <div class="bottom-section">
          <div class="disclaimer">
            The results are AI-generated, User validation is required.
          </div>
          <!-- doc list -->
 <ng-container *ngIf="classifiedGroupKeys.length > 0; else noDocumentsFound">
  <div class="doc-list-row document-list-bordered"
    style="margin-bottom:16px; margin-top: 16px; margin-right: 24px; border: 1px solid #000; border-radius: 8px; display: flex; flex-direction: column; align-items: flex-start;">
    <div style="width: 100%; display: flex; align-items: center; justify-content: flex-start; padding: 12px 16px;">
      <div style="font-size: 18px; font-weight: 400; font-family: EYInterstate;">Borrower Source Documents</div>
    </div>
    <div class="doc-classification-docs" style="flex: 1; width: 100%; overflow-x: auto; margin-bottom: 5px;">
      <div style="display: flex; flex-direction: row; gap: 16px; width: max-content; justify-content: flex-start;">
        <ng-container *ngFor="let group of classifiedGroupKeys">
          <div style="display: flex; flex-direction: column; align-items: flex-start;">
            <div style="display: flex; flex-direction: row; gap: 12px;">
              <div *ngFor="let doc of classifiedDocuments[group]" class="doc-card"
                [class.selected]="(doc.id || doc.doc_id) === selectedDocumentId"
                (click)="selectDocumentById(doc.id || doc.doc_id)">
                <div
                  style="display: flex; align-items: center; justify-content: center; height: 48px; min-height: 48px; max-height: 48px; gap: 8px; flex-direction: column; align-items: flex-start; justify-content: flex-start;">
                  <div style="display: flex; align-items: center; gap: 8px;">
                    <mat-icon class="doc-icon" style="font-size: 24px;" [ngStyle]="{
                        color: ((doc.fileType && doc.fileType.toLowerCase() === 'pdf') || (doc.original_filename && doc.original_filename.toLowerCase().endsWith('.pdf')) || (doc.file_name && doc.file_name.toLowerCase().endsWith('.pdf')) || (doc.name && doc.name.toLowerCase().endsWith('.pdf'))) ? '' : '#388E3C'
                      }">
                      {{ (doc.fileType && doc.fileType.toLowerCase() === 'pdf') || (doc.original_filename &&
                      doc.original_filename.toLowerCase().endsWith('.pdf')) || (doc.file_name &&
                      doc.file_name.toLowerCase().endsWith('.pdf')) || (doc.name &&
                      doc.name.toLowerCase().endsWith('.pdf')) ? 'picture_as_pdf' : 'description' }}
                    </mat-icon>
                    <div class="doc-name" style="font-size: 15px; font-weight: 400;">{{ doc.original_filename ||
                      doc.file_name || doc.name || 'Document' }}</div>
                  </div>
                  <div *ngIf="doc.doc_classification" class="doc-classification"
                    style="font-size: 13px; color: #7660ff; font-weight: 500; margin-top: 2px; margin-left: 36px; font-family: EYInterstate !important;">{{
                    doc.doc_classification }}</div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</ng-container>
<ng-template #noDocumentsFound>
  <div class="doc-list-row document-list-bordered" style="margin-bottom:16px; margin-top: 16px; margin-right: 24px; border: 1px solid #000; border-radius: 8px; display: flex; align-items: center; justify-content: center; min-height: 64px; background: #f5f3ff;">
    <span style="font-size: 16px; color: #888; font-weight: 500;">No documents found.</span>
  </div>
</ng-template>
          <div class="result-box" #resultBox style="margin-bottom: 24px; margin-top: 40px">
            <div class="title" style="margin-top: 10px; display: flex; align-items: center; gap: 16px;">
              <span>Document View</span>
              <ng-container *ngIf="!showNoDocument">
                <span *ngIf="selectedDocumentIndex === -1 && selectedChunk" class="doc-info" style="font-size: 15px; font-weight: 400; color: #fff; background: #1976d2 !important; border-radius: 6px; padding: 4px 10px; margin-left: 8px; border: 1px solid #7660ff; display: flex; align-items: center; gap: 8px;">
                  <span style="font-family: EYInterstate !important; font-weight: 400; margin-bottom: 2px;">Filename:</span> {{ selectedChunk.original_filename || selectedChunk.file_name || selectedChunk.name || 'N/A' }}
                  <span *ngIf="selectedChunk.category"> | <strong>Category:</strong> {{ selectedChunk.category }}</span>
                </span>
                <span *ngIf="selectedDocumentIndex >= 0 && documentList[selectedDocumentIndex] as selectedDocument" class="doc-info" style="font-size: 15px; font-weight: 400; color: #fff; background: #1976d2 !important; border-radius: 6px; padding: 4px 10px; margin-left: 8px; border: 1px solid #7660ff; display: flex; align-items: center; gap: 8px;">
                  <span style="font-family: EYInterstate !important; font-weight: 400; margin-bottom: 2px;">Filename:</span> {{ selectedDocument.original_filename || selectedDocument.file_name || selectedDocument.name || 'N/A' }}
                  <span *ngIf="selectedDocument.category"> | <strong>Category:</strong> {{ selectedDocument.category }}</span>
                </span>
              </ng-container>
            </div>
            <div
              *ngIf="!showNoDocument && isCurrentPdf || isPdfLoading"
              style="
                display: flex;
                justify-content: flex-end;
                align-items: center;
                width: 100%;
                padding-right: 40px;
              "
            >
              <button
                (click)="closePdf()"
                style="
                  color: white;
                  background: black;
                  border: none;
                  font-size: 1rem;
                  cursor: pointer;
                  width: 24px;
                  height: 24px;
                  border-radius: 50%;
                  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                &times;
              </button>
            </div>
            <div *ngIf="!showNoDocument" style="width: 80%; margin: 24px 24px">
              <iframe *ngIf="pdfUrl" [src]="pdfUrl" style="width: 85vw; margin-right: 10px; height: 100vh; min-height: 100vh; max-height: 100vh; display: block; margin: 0 auto; border: none;"></iframe>
              <div
                *ngIf="isPdfLoading"
                style="
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  transform: translate(-50%, -50%);
                  z-index: 10;
                "
              >
                <mat-progress-spinner
                  class="pdf-loader"
                  mode="indeterminate"
                  diameter="48"
                  style="
                    margin-top: 1050px;
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    align-items: center;
                  "
                ></mat-progress-spinner>
              </div>
            </div>
            @if(this.showNoDocument) {
            <div class="result-box-no-data">
              <div class="img-box">
                <img src="images/no-file.png" alt="" />
              </div>
              <div class="no-data-text">No document selected.</div>
              <div class="no-data-sub-text">
                User needs to click the icon under the "Source Documents" column
                to view the Document.
              </div>
            </div>
            }
          </div>
          </div>
          <button
            *ngIf="showSideKick && isMappingResultRoute"
            class="floating-sidekick-btn"
            mat-fab
            (click)="showChatbot()"
          >
            Chatbot
          </button>
<div
  class="modal"
  [ngStyle]="{ display: isSectionModalOpen ? 'block' : 'none' }"
  (click)="closeSectionModal()"
>
  <ng-container *ngIf="sectionInfoResult$ | async as sectionInfoResult; else loadingSectionModal">
    <div
      class="modal-content section-modal-content"
      style="position: relative;"
      (click)="$event.stopPropagation()"
    >
      <span
        class="close"
        (click)="closeSectionModal()"
        style="
          position: absolute;
          top: 10px;
          right: 16px;
          font-size: 28px;
          cursor: pointer;
        "
        >&times;</span
      >
      <div
        style="
          padding-top: 12px;
          text-align: center;
          font-family: EYInterstate !important;
          font-size: 18px;
        "
      >
        {{ sectionModalTitle }}
      </div>
      <div *ngIf="sectionInfoResult.section_markdown" class="section-markdown-scroll" style="margin-top: 24px; max-height: 60vh; overflow: auto;">
        <div #sectionHtml [innerHTML]="sectionInfoResult.section_markdown | markedHtml"></div>
      </div>
    </div>
  </ng-container>
  <ng-template #loadingSectionModal>
    <div class="modal-content section-modal-content" style="position: relative; min-height: 200px; display: flex; align-items: center; justify-content: center;" (click)="$event.stopPropagation()">
      <mat-progress-spinner mode="indeterminate" diameter="48"></mat-progress-spinner>
    </div>
  </ng-template>
</div>
